module.exports = __webpack_public_path__ + "img/billing.42ee5e5e.png";